const comparisonTableTabs = [
    {
        selector: '[data-comparison-table-tabs]',
        path: { filename: 'comparisonTableTabs' },
    },
];

export { comparisonTableTabs };
